'use client';

import { createContext, useContext, type ReactNode } from 'react';

export type EvidenceActions = {
  add: (artifactId: string, description: string) => Promise<void>;
  update: (artifactId: string, description: string) => Promise<void>;
  remove: (artifactId: string) => Promise<void>;
};

const AddToEvidenceContext = createContext<EvidenceActions | undefined>(
  undefined,
);

type AddToEvidenceProviderProps = {
  children: ReactNode;
  onAddToEvidence: (artifactId: string, description: string) => Promise<void>;
  onUpdateEvidence: (artifactId: string, description: string) => Promise<void>;
  onRemoveEvidence: (artifactId: string) => Promise<void>;
};

export function AddToEvidenceProvider({
  children,
  onAddToEvidence,
  onUpdateEvidence,
  onRemoveEvidence,
}: AddToEvidenceProviderProps) {
  const actions: EvidenceActions = {
    add: onAddToEvidence,
    update: onUpdateEvidence,
    remove: onRemoveEvidence,
  };

  return (
    <AddToEvidenceContext.Provider value={actions}>
      {children}
    </AddToEvidenceContext.Provider>
  );
}

export function useAddToEvidence(): EvidenceActions | undefined {
  return useContext(AddToEvidenceContext);
}
